// Autogenerated file
export const outputIndexesGroupingTypesEnum = {
    ByDays: "ByDays",
    ByWeeks: "ByWeeks",
    ByMonths: "ByMonths",
};
export const outputIndexesGroupingTypes = [
    { label: "По дням", value: "ByDays" },
    { label: "По неделям", value: "ByWeeks" },
    { label: "По месяцам", value: "ByMonths" },
];
